import { useState, DragEvent, useEffect } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";

import { H1, H2 } from "../../../../AbstractElements";
import { WILL_BE_UPLOADED } from "../../../../Api/constants";
import FileHandler from "../../../../CommonElements/FileHandler";
import { extractFileName } from "../../../../utils/helper/helper";

import "./style.scss";
interface SequenceItem {
  option_id: number;
  option_text: string;
}

interface SequencingProps {
  question: any;
  onAnswerChange: (question_id: number, answers: any) => void;
  savedAnswer: any;
  questionNumber: string;
  mediaUrl?: string;
}

const Sequencing = ({
  question,
  onAnswerChange,
  savedAnswer,
  questionNumber,
  mediaUrl,
}: SequencingProps) => {
  const [items, setItems] = useState<SequenceItem[]>([]);
  const [draggedItem, setDraggedItem] = useState<SequenceItem | null>(null);

  useEffect(() => {
    if (question && question.options) {
      if (savedAnswer && savedAnswer.answers) {
        const orderedItems = savedAnswer.answers
          .sort((a, b) => a.sequence - b.sequence)
          .map(answer =>
            question.options.find(opt => opt.option_id === answer.option_id)
          )
          .filter(Boolean); // Filter out undefined if any option not found
        setItems(orderedItems);
      } else {
        setItems([...question.options]);
      }
    }
  }, [question, savedAnswer]);

  const handleDragStart = (e: DragEvent<HTMLElement>, item: SequenceItem) => {
    setDraggedItem(item);
    e.currentTarget.classList.add("dragging");
  };

  const handleDragOver = (e: DragEvent<HTMLElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: DragEvent<HTMLElement>, targetItem: SequenceItem) => {
    e.preventDefault();
    if (!draggedItem || draggedItem.option_id === targetItem.option_id) {
      return;
    }

    const newItems = [...items];
    const draggedIndex = newItems.findIndex(
      i => i.option_id === draggedItem.option_id
    );
    const targetIndex = newItems.findIndex(
      i => i.option_id === targetItem.option_id
    );

    // Swap items
    newItems.splice(draggedIndex, 1);
    newItems.splice(targetIndex, 0, draggedItem);

    setItems(newItems);
    onAnswerChange(
      question.question_id,
      newItems.map((item, index) => ({
        option_id: item.option_id,
        sequence: index + 1,
      }))
    );
  };

  const handleDragEnd = (e: DragEvent<HTMLElement>) => {
    e.currentTarget.classList.remove("dragging");
    setDraggedItem(null);
  };

  return (
    <div className="sequencing-question">
      <H1 className="sequencing-question__question">{questionNumber}</H1>
      <H2 className="sequencing-question__title">{question?.question_text}</H2>
      {mediaUrl && extractFileName(mediaUrl) !== WILL_BE_UPLOADED && (
        <FileHandler showPreview={true} mediaUrl={mediaUrl} />
      )}
      <ListGroup className="sequence-list">
        {items.map((item, index) => (
          <ListGroupItem
            key={item.option_id}
            draggable
            onDragStart={e => handleDragStart(e, item)}
            onDragOver={handleDragOver}
            onDrop={e => handleDrop(e, item)}
            onDragEnd={handleDragEnd}
            className="sequence-item"
          >
            <span className="sequence-number">{index + 1}.</span>
            {item.option_text}
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};

export default Sequencing;
